(function () {
  if (window.__footerAccordionGroupBound) return;
  window.__footerAccordionGroupBound = true;

  /**
   * @param {Element} container
   */
  function closeAllAccordions(container) {
    container.querySelectorAll('accordion-custom details').forEach(function (el) {
      if (el instanceof HTMLDetailsElement) {
        el.open = false;
      }
    });
  }

  function closeAllInDocument() {
    document.querySelectorAll('[data-footer-accordion-single]').forEach(closeAllAccordions);
  }

  document.addEventListener(
    'toggle',
    function (e) {
      const target = e.target;
      if (!(target instanceof HTMLDetailsElement) || !target.open) return;
      const nav = target.closest('[data-footer-accordion-single]');
      if (!nav) return;
      nav.querySelectorAll('accordion-custom details').forEach(function (other) {
        if (other !== target && other instanceof HTMLDetailsElement) {
          other.open = false;
        }
      });
    },
    true,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', closeAllInDocument);
  } else {
    closeAllInDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target;
    if (!root || typeof root.querySelector !== 'function') return;
    const nav = root.querySelector('[data-footer-accordion-single]');
    if (nav) closeAllAccordions(nav);
  });
})();
